export function getSearchParams() {
  return new URLSearchParams(window.location.search)
}

export function getSearchString() {
  return window.location.search
}

export function getPathname() {
  return window.location.pathname
}
